import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNotificationContext } from "contexts/NotificationContext";
import { useNavigate, useParams } from "react-router-dom";
import { RouteName } from "constants/route";
import { ILoadingWithPage } from "models";
import { IUpdateDriverWalletInput } from "models/driverWallet";
import { updateWalletValidator } from "validators/createWallet.validator";
import { fetchWalletByIdApi, updateWalletApi } from "api/wallet";

export default function useEditDriverWallet() {
  const id: string = useParams().id!;
  const navigate = useNavigate();
  const { showError, showSuccess } = useNotificationContext();
  const [loading, setLoading] = useState<ILoadingWithPage>({
    button: false,
    page: true,
  });
  const { control, handleSubmit, setValue } = useForm<IUpdateDriverWalletInput>(
    {
      resolver: yupResolver(updateWalletValidator),
    }
  );

  useEffect(() => {
    fetchWalletByIdApi(id).then(({ data, error }) => {
      if (data?.data) {
        setValue("bank", data.data.bank);
        setValue("account", data.data.account);
        setValue("balance" as any, data.data.balance.toString());
        setLoading({ button: false, page: false });
      } else showError(error!.message);
    });
    // eslint-disable-next-line
  }, [id]);

  const onSubmit = async (input: IUpdateDriverWalletInput) => {
    setLoading({ button: true, page: false });
    const { data, error } = await updateWalletApi(id, input);
    if (data) {
      showSuccess("Wallet updated Successfully");
      navigate(RouteName.DRIVER_WALLET, { replace: true });
    } else {
      showError(error!.message);
    }
    setLoading({ button: false, page: false });
  };

  return { handleSubmit, onSubmit, control, loading };
}
